<template>
    <div class="login-new-page">
      <div class="login-new-page-resources">
        <img :src="cnLogo" alt="thecn.com" class="cn-logo" />
        <div class="resources-container" v-if="links.length">
          <h2>
            Resources
          </h2>
          <b-card
            v-for="(link, index) in links"
            :key="index"
            :img-src="screenShots[index]"
            img-alt="Card image"
            img-width="128"
            img-left
          >
            <b-card-text>
              <a :href="link.value" target="_blank">
                <span>
                  {{ link.name }}
                </span>
                <i class="fa fa-arrow-circle-o-right"></i>
              </a>
            </b-card-text>
          </b-card>
        </div>
      </div>
      <slot></slot>
    </div>
  </template>
  
  <script>

  import { mapState } from "vuex";
  
  export default {
    components: {

    },
    data() {
      return {
        cnLogo: require("@/assets/img/cn_logo2.png"),
        screenShots: [
          require("@/assets/img/screen_shot.png"),
          require("@/assets/img/screenshot2.png"),
          require("@/assets/img/screenshot3.jpg"),
        ],
      };
    },
    computed: {
      ...mapState("siteBrand", ["links", "heading"]),
    },
  };
  </script>
  
  <style scoped lang="scss">
  .cn-logo {
    height: rem(32);
    margin: 0 0 rem(40) 0;
  }
  .login-new-page {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap-reverse;
    > div {
      flex: 1;
      min-width: 300px;
    }
    &-resources {
      padding: rem(40);
      .cn-logo {
        display: inline-block;
      }
      @media all and (max-width: 768px) {
        padding: rem(20);
        .cn-logo {
          display: none;
        }
      }
      .resources-container {
        h2 {
          font-weight: 700;
          font-size: rem(20);
          line-height: rem(27);
          color: #1a374d;
        }
        .card {
          padding: rem(25) 0;
          margin: 0 rem(15);
          border: none;
          border-radius: 0;
          @media all and (max-width: 768px) {
            margin: rem(0);
          }
          &:not(:last-child) {
            border-bottom: 0.5px solid rgba(173, 173, 173, 0.5);
          }
          .card-text {
            a {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            span {
              font-weight: 400;
              font-size: rem(16);
              line-height: rem(22);
              color: #1a374d;
            }
            .fa-arrow-circle-o-right {
              font-size: rem(24);
            }
          }
        }
      }
    }
  }
  </style>
  